import { render, staticRenderFns } from "./VircosMeasures.vue?vue&type=template&id=ae08beee&scoped=true&"
import script from "./VircosMeasures.vue?vue&type=script&lang=js&"
export * from "./VircosMeasures.vue?vue&type=script&lang=js&"
import style0 from "./VircosMeasures.vue?vue&type=style&index=0&id=ae08beee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae08beee",
  null
  
)

export default component.exports